import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthInterceptorService } from '@core/interceptors/auth-interceptor.service';
import {MaterialModule} from "@modules/material/material.module";
import { ModalModule } from '@shared/components/modal/modal.module';

import { RxStompService } from '@core/services/stomp.service';
import { rxStompServiceFactory } from '@core/services/stomp-service-factory';
import { ModalMessageComponent } from '@shared/components/modal-message/modal-message.component';
import { ModalInfoComponent } from './shared/components/modal-info/modal-info.component';
import { OrgInterceptorService } from '@core/interceptors/org-interceptor.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { SpanishPaginator } from '@shared/components/gca-table/spanish-implementation/spanish-paginator';


@NgModule({
  declarations: [ AppComponent, ModalMessageComponent, ModalInfoComponent ],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        MaterialModule,
        ReactiveFormsModule,
    ],
  providers:[
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OrgInterceptorService,
      multi: true
    },
    {
      provide: RxStompService,
      useFactory: rxStompServiceFactory,
    },
    {
      provide: MatPaginatorIntl,
      useClass: SpanishPaginator
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
